<div class="container mt-4">
    <div class="row">
        <div class="col-md-12">
            <div class="main-timeline">
                <div class="triangle-box position-relative text-center">
                    <div class='arrow-icon'></div>
                </div>
                <div class="timeline" *ngFor="let item of educationData">
                    <!-- <span class="timeline-icon"></span> -->
                    <!-- <a class="timeline-content">
                        <div class="timeline-year"><span>{{item.endYear}}</span></div>
                        <h3 class="title">{{item?.degreeType?.name}} - {{item?.fieldOfStudy}} <i class="fa fa-graduation-cap"></i></h3>
                        <p class="description">
                            {{item?.university}},{{item?.country?.countryName}}
                        </p>
                    </a> -->
                    
                    <a class="timeline-content">
                        <div class="row">
                         <!-- <div class="col-2"><h3><i class="timeline-custom-icon fa fa-graduation-cap"></i></h3></div> -->
                         <div class="col">                            
                            <h3 class="title">{{item?.degreeType?.name}} - {{item?.fieldOfStudy}}</h3>
                            <p class="description">
                                {{item?.university}},{{item?.country?.countryName}}
                            </p>
                         </div>
                        </div>   
                        <div class="timeline-duration ed-duration position-absolute"><span>{{item.endYear}}</span></div>                     
                    </a>
                </div>                
            </div>
            <div class="rounded-area">
                <div class="rounded-area-inner"></div>
            </div> 
        </div>
    </div>
</div>